// Imports
import { useEffect, useState } from 'react';
import LoadingRow from '../../../../../../shareables/foundation/front-end/components/tables/loading-row';
import { useAppDispatch } from '../../../../../../shareables/foundation/front-end/redux/hooks';
import apiActions from '../../../../../../shareables/integrations/api/redux/actions';
import { GetContactItemsResponse } from '../../../../../../shareables/types/api/main/website/page/type/217/contact-items/get';
import Table from '../shared-components/table';
import EmptyStateRow from '../shared-components/table/empty-state-row';
import UsefulContactInformationRow from './row';


// Define the accepted props
interface Props {
	pageID: number;
	storybookContactItems?: GetContactItemsResponse;
}


// Function component
const UsefulContactInformation: React.FC<Props> = ({ pageID, storybookContactItems }) => {
	// Use state
	const [contactItems, setContactItems] = useState<GetContactItemsResponse | null>(storybookContactItems ?? null);
	
	
	// Use Redux functionality
	const dispatch = useAppDispatch();
	
	
	// Load contact information items on mount
	useEffect(() => {
		void dispatch(
			apiActions.call<undefined, undefined, GetContactItemsResponse>({
				action: 'GET',
				uri: `/website/${window.location.hostname}/page/id_${pageID}/type/217/contact-items`,
				completion: (json) => {
					setContactItems(json.response);
				},
			})
		);
	}, [dispatch, pageID]);
	
	
	// Return JSX
	return (
		<div>
			<Table>
				<thead>
					<tr>
						<th>Who</th>
						<th>Contact info</th>
					</tr>
				</thead>
				
				<tbody>
					{contactItems?.map((info) => (
						<UsefulContactInformationRow key={info.id} contactInfo={info}></UsefulContactInformationRow>
					))}
					
					{contactItems?.length === 0 && <EmptyStateRow>No useful contact information yet…</EmptyStateRow>}
					
					{!contactItems && <LoadingRow />}
				</tbody>
			</Table>
		</div>
	);
};

export default UsefulContactInformation;
